import {Digits} from '../constants';

import type {Digit} from '../constants';

const digits: string[] = [
    Digits.ONE,
    Digits.THOUSAND,
    Digits.MILLION,
    Digits.BILLION,
    Digits.TRILLION,
    Digits.QUADRILLION,
];
type ConvertToDigit = (options: {
    value: number,
    toDigit?: Digit,
    fromDigit?: Digit,
    preventScale?: boolean,
}) => {
    value: number,
    digit: Digit,
};

/**
 * @description Convert a numeric value to a digit
 * @param {number} params.value - Input value
 * @param {Digit=} params.toDigit - Output digit
 * @param {Digit=} params.fromDigit - Input digit
 * @param [params.preventScale=false] - should convert digit
 * @return {{value:number,digit:Digit}} value with converted digit
 */
export const convertToDigit: ConvertToDigit = params => {
    const {
        value,
        toDigit,
        fromDigit = Digits.ONE,
        preventScale = false,
    } = params;

    // eslint-disable-next-line @typescript-eslint/no-shadow
    const scale = (value: number, digit: Digit): {value: number, digit: Digit} => {
        const index = digits.indexOf(digit);
        const nextDigit = index !== -1 ? digits[index + 1] : digit;
        const maxIndex = digits.length - 1;
        const noScale = Math.abs(value) < 1000 || preventScale;

        if (
            (noScale && (!toDigit || index >= digits.indexOf(toDigit))) ||
            index === maxIndex
        ) {
            return {
                value,
                digit,
            };
        } else {
            return scale(value / 1000, nextDigit);
        }
    };

    return scale(value, fromDigit);
};
